/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/accounting'
export default icon
